import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private http: HttpClient) { }

  fetchUserGroups(): Observable<String[]> {
    return this.http.get<String[]>('/admin/users/groups')
  }


}
